import React from 'react';

function Paiements() {
  return (
    <div>
      <h1>Paiements</h1>
      <p>Page à implémenter</p>
    </div>
  );
}

export default Paiements;
